import { render, staticRenderFns } from "./teams-hero.vue?vue&type=template&id=981c9b28&"
import script from "./teams-hero.vue?vue&type=script&lang=js&"
export * from "./teams-hero.vue?vue&type=script&lang=js&"
import style0 from "./teams-hero.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports